import { createAction } from 'redux-act';
import { IDomain } from '../reducers/domains';

export const fetchDomains = createAction();
export const fetchDomainsSuccess = createAction<IDomain[]>();
export const fetchDomainsFailed = createAction();
